import styled from 'styled-components';

export default styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  line-height: 100%;
  li {
    display: block;
    margin: 0;
    padding: 0;
    list-style: none;
  }
`;
